module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_DB1A.067afa77.jpg";